
/**
 * Represents a color's red, green, blue and alpha values in the 0...1 range
 */
export class ColorModel {
    constructor(
        public red: number,
        public green: number,
        public blue: number,
        public alpha: number = 1
    ) { }
}
